import PropTypes from 'prop-types';

const UnpinIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m34.27 21.048 2.154 7.499a2.477 2.477 0 0 1-.64 2.45 2.459 2.459 0 0 1-1.747.717l-5.878.005-3.38 14.617a.79.79 0 0 1-.216.385.787.787 0 0 1-.56.232.81.81 0 0 1-.786-.617l-2.665-11.522L34.27 21.048zM46.034.858l.006.006a1.94 1.94 0 0 1 0 2.737L4.32 45.503a1.922 1.922 0 0 1-2.724 0 1.94 1.94 0 0 1 0-2.737L43.316.864a1.922 1.922 0 0 1 2.718-.006zM14.477.571 33.53.573c.214 0 .412.085.565.238a.807.807 0 0 1 .232.56c0 1.249-.223 2.445-.63 3.552L12.151 26.541l4.996-17.45-.305-.278a10.254 10.254 0 0 1-3.174-7.444.814.814 0 0 1 .808-.798z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

UnpinIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

UnpinIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default UnpinIcon;
